
const getTimecardLineItem = (invoices, timecardId) => {
  let lineItem;
  invoices.forEach(invoice => {
    invoice.lineItems.forEach(item => {
      if (item.timecardId === timecardId) {
        lineItem = item;
      }
    });
  });

  return lineItem;
};

const reduceTimecardMetrics = (invoices, timecards, workTypes) =>
  timecards.reduce((metric, timecard) => {
    const lineItem = getTimecardLineItem(invoices, timecard.id);

    if (lineItem) {
      metric.invoicedTotal += lineItem.total;
    } else {
      const workType = workTypes.find(workType => workType.id === timecard.workTypeId);
      const quantity = timecard.minutesWorked
        ? Number((timecard.minutesWorked/60).toFixed(1))
        : 0;
      const unitPrice = workType
        ? Number(Number(workType.rate).toFixed(2))
        : 0;
      const total = Number((quantity*unitPrice).toFixed(2));

      metric.timecardsToInvoice++;
      metric.notInvoicedTotal += total;
    }

    return metric;
  },
  {
    timecardsToInvoice: 0,
    invoicedTotal: 0,
    notInvoicedTotal: 0
  });

export const selectTimecardsMetrics = (store) => {
  const invoices = store.invoicesState;
  const timecards = store.timecardsState.filter(timecard => timecard.billToClient);
  const workTypes = store.workTypesState;

  const metrics = reduceTimecardMetrics(invoices, timecards, workTypes);

  return [
    {
      type: "horizontal",
      label: "Time Cards to invoice",
      display: metrics.timecardsToInvoice,
    },
    {
      type: "vertical",
      label: "invoiced",
      display: `$${metrics.invoicedTotal.toFixed(2)}`,
    },
    {
      type: "vertical",
      label: "not invoiced",
      display: `$${metrics.notInvoicedTotal.toFixed(2)}`,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/store/selectors/metrics/timecards.js